import { COUNTRY_OPTIONS } from "../constants/common";
/*istanbul ignore next */
export const getFileExtension = (fname) => {
  return fname
    .slice((Math.max(0, fname.lastIndexOf(".")) || Infinity) + 1)
    .toLowerCase();
};
/*istanbul ignore next */
export const amountFormat = (amount) => {
  const doller = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  return doller.format(amount);
};
/*istanbul ignore next */
export const getFrequency = (frequencyValue) => {
  frequencyValue = Number(frequencyValue);

  if (frequencyValue === 1) {
    return 1;
  } else if (frequencyValue === 2) {
    return 3;
  } else if (frequencyValue === 3) {
    return 6;
  } else if (frequencyValue === 4) {
    return 12;
  } else if (frequencyValue === 99) {
    return 1;
  } else {
    return 0;
  }
};
/*istanbul ignore next */
export const handleStateChange = (
  event,
  stateNames,
  selected,
  setSelected,
  states
) => {
  const NA_VAL = "Not Applicable";
  const value = event.target.value;
  if (value[value.length - 1] === "all") {
    let sNames = stateNames.filter((e) => e !== NA_VAL);
    setSelected(selected.length === stateNames.length - 1 ? [] : sNames);

    return selected.length === stateNames.length - 1 ? [] : sNames;
  } else if (value.includes(NA_VAL) || states?.includes(NA_VAL)) {
    if (selected.includes(NA_VAL)) {
      setSelected(value.filter((e) => e !== NA_VAL));
      return value.filter((e) => e !== NA_VAL);
    } else {
      setSelected([NA_VAL]);
      return [NA_VAL];
    }
  } else {
    setSelected(value);
    return value;
  }
};
/*istanbul ignore next */
export const fetchImageAsBase64 = async (imageUrl) => {
  const response = await fetch(imageUrl);
  const blob = await response.blob();
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onload = () => {
      const base64Data = reader.result.split(",")[1];
      resolve(base64Data);
    };

    reader.onerror = () => {
      reject(new Error("Failed to read image as Base64"));
    };

    reader.readAsDataURL(blob);
  });
};
/*istanbul ignore next */
export const getPhoneCode = (countryOptions, countryId) => {
  if (Number(countryId) > 0) {
    return countryOptions
      ?.filter((el) => el.countryId === Number(countryId))
      ?.map((item) => item.phoneCode);
  } else {
    return ["+1"];
  }
};

export const isCountryCanada = (countryId) =>
  Number(countryId) === COUNTRY_OPTIONS.CANADA;

export const getZipLabel = (countryId) =>
  isCountryCanada(countryId) ? "Billing Postal Code" : "Billing Zip Code";

export const getBillingZipLabel = (countryId) =>
  isCountryCanada(countryId) ? "Postal Code" : "Zip Code";

export const getShippingZipLabel = (countryId) =>
  isCountryCanada(countryId) ? "Postal Code" : "Zip Code";

export const getZipPlaceholder = (countryId) =>
  isCountryCanada(countryId)
    ? "Enter Billing Postal Code"
    : "Enter Billing Zip Code";
export const getBillingZipPlaceholder = (countryId) =>
  isCountryCanada(countryId) ? "Enter Postal Code" : "Enter Zip Code";

export const getShippingZipPlaceholder = (countryId) =>
  isCountryCanada(countryId)
    ? "Enter Shipping Postal Code"
    : "Enter Shipping Zip Code";

export const getMaxLength = (countryId) =>
  isCountryCanada(countryId) ? 7 : 10;
